/**
 * Returns whether the given object matches the CesiumIonAssetEndpointAttribution type
 * @param obj Object to check
 */
export function isCesiumIonAssetEndpointAttribution(obj) {
    if (typeof obj !== "object" || obj === null)
        return false;
    if (typeof obj.html !== "undefined" && typeof obj.html !== "string")
        return false;
    if (typeof obj.collapsible !== "undefined" && typeof obj.collapsible !== "boolean")
        return false;
    return true;
}
